import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

interface FilterBarProps {
  activeCategory: string;
  onCategoryChange: (slug: string) => void;
  sort: 'latest' | 'hot';
  onSortChange: (sort: 'latest' | 'hot') => void;
  query: string;
  onQueryChange: (value: string) => void;
  total: number;
}

export default function FilterBar({
  activeCategory,
  onCategoryChange,
  sort,
  onSortChange,
  query,
  onQueryChange,
  total,
}: FilterBarProps) {
  const tabs = [{ slug: 'all', name: '全部栏目' }, ...categories.map((item) => ({ slug: item.slug, name: item.name }))];

  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
      <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
        <div className="flex flex-1 flex-col gap-3">
          <div className="flex flex-wrap gap-2">
            {tabs.map((tab) => (
              <button
                key={tab.slug}
                type="button"
                aria-pressed={activeCategory === tab.slug}
                onClick={() => onCategoryChange(tab.slug)}
                className={`whitespace-nowrap rounded-full px-3.5 py-1.5 text-sm transition-colors ${
                  activeCategory === tab.slug
                    ? 'bg-primary-500 font-medium text-background-50'
                    : 'border border-background-300 text-foreground-700 hover:border-primary-300 hover:text-primary-700'
                }`}
              >
                {tab.name}
              </button>
            ))}
          </div>
        </div>

        <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
          <label className="flex items-center gap-2 rounded-md border border-background-300 bg-background-50 px-3 py-2 focus-within:border-primary-400">
            <span className="flex h-4 w-4 items-center justify-center text-foreground-500">
              <i className="ri-search-line text-base" aria-hidden="true" />
            </span>
            <input
              type="search"
              value={query}
              onChange={(event) => onQueryChange(event.target.value)}
              placeholder="搜索话题关键词"
              aria-label="搜索话题"
              className="w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-500 sm:w-40"
            />
          </label>

          <div className="flex items-center rounded-md border border-background-300 p-1">
            {(['latest', 'hot'] as const).map((item) => (
              <button
                key={item}
                type="button"
                onClick={() => onSortChange(item)}
                aria-pressed={sort === item}
                className={`flex-1 whitespace-nowrap rounded px-3 py-1 text-xs transition-colors sm:flex-none ${
                  sort === item ? 'bg-foreground-950 font-medium text-background-50' : 'text-foreground-700'
                }`}
              >
                {item === 'latest' ? '最新更新' : '最热'}
              </button>
            ))}
          </div>
        </div>
      </div>

      <div className="mt-4 flex flex-wrap items-center justify-between gap-2 border-t border-background-200 pt-3 text-xs text-foreground-600">
        <span>
          共找到 <strong className="text-foreground-900">{total}</strong> 条相关话题
        </span>
        <Link to="/" className="flex items-center gap-1 hover:text-primary-700">
          <i className="ri-arrow-left-line" aria-hidden="true" />
          返回首页看实时上新
        </Link>
      </div>
    </div>
  );
}